import axios from "../../../utils/axios";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    InternalMfaEnrollment,
    InternalMfaStatus,
    InternalMfaVerification,
} from "../types/mfa";

export async function fetchInternalMfaStatus(): Promise<InternalMfaStatus> {
    const response = await axios.get<IApiResponse<InternalMfaStatus>>(
        "/auth/mfa/status",
        { skipUnauthorizedLogout: true }
    );
    return response.data.data;
}

export async function startInternalMfaEnrollment(): Promise<InternalMfaEnrollment> {
    const response = await axios.post<IApiResponse<InternalMfaEnrollment>>(
        "/auth/mfa/enrollment",
        undefined,
        { skipUnauthorizedLogout: true }
    );
    return response.data.data;
}

export async function completeInternalMfaEnrollment(
    code: string
): Promise<InternalMfaVerification> {
    const response = await axios.post<IApiResponse<InternalMfaVerification>>(
        "/auth/mfa/enrollment/verify",
        { code },
        { skipUnauthorizedLogout: true }
    );
    return response.data.data;
}

export async function verifyInternalMfa(
    code: string
): Promise<InternalMfaVerification> {
    const response = await axios.post<IApiResponse<InternalMfaVerification>>(
        "/auth/mfa/verify",
        { code },
        { skipUnauthorizedLogout: true }
    );
    return response.data.data;
}
